import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

export const Route = createFileRoute("/es/partners/referidos")({
  loader: async () => { await setEdgeHtmlCache({ sMaxAge: 1800 }); },
  head: () => buildHead({
    locale: "es",
    title: "Programa de Referidos Shopify · Gana 20% | Shugert",
    description: "Refiere una marca Shopify a Shugert y gana 20% del ingreso neto elegible del primer engagement, hasta $5,000 USD por cliente.",
    path: "/es/partners/referidos",
    altPath: alternatePath("/es/partners/referidos", "en"),
    jsonLd: [
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Partners de referidos", path: "/es/partners/referidos" }]),
      webPageJsonLd({ name: "Programa de Referidos Shugert", path: "/es/partners/referidos", description: "Programa para agencias, consultores, developers y partners tecnológicos que presentan marcas Shopify a Shugert.", inLanguage: "es-MX" }),
    ],
  }),
});
